import { describeApiError, isInsufficientCredits, isSubscriptionExpired } from "$lib/api/errors";
import { billingAwareToastCopy, toastVariantForError, userErrorMessage } from "$lib/api/userError";
import { toast } from "$lib/stores/toast.svelte";

/** Toast the user-facing message; returns the toast id. */
export function toastApiError(err: unknown, fallback?: string): number {
  if (isSubscriptionExpired(err) || isInsufficientCredits(err)) {
    const copy = billingAwareToastCopy(err, fallback);
    return toast.show({
      variant: toastVariantForError(err),
      title: copy.title,
      description: copy.description,
    });
  }

  const title = userErrorMessage(err, fallback);
  const described = describeApiError(err, title);
  const fields = Object.entries(described.fields);
  const description =
    fields.length > 1
      ? fields.map(([key, msg]) => `${key}: ${msg}`).join("\n")
      : fields.length === 1 && described.message !== fields[0][1]
        ? `${fields[0][0]}: ${fields[0][1]}`
        : null;

  return toast.show({
    variant: toastVariantForError(err),
    title,
    description,
  });
}
